import type { SignalClient } from "../signalClient";
import type { Transport } from "./transport";

/**
 * Запасной путь: пакеты боя через сводник (WebSocket), если прямой WebRTC не встал. Медленнее на перекличку TCP,
 * но откат кадров это переживает. По Tailscale сводник стоит на ПК Джона.
 */
export function relayTransport(signal: SignalClient): Transport {
  let handler: (bytes: Uint8Array) => void = () => undefined;
  signal.on((message) => {
    if (message.t !== "relay") return;
    const binary = atob(message.data);
    const bytes = new Uint8Array(binary.length);
    for (let index = 0; index < binary.length; index++) bytes[index] = binary.charCodeAt(index);
    handler(bytes);
  });
  return {
    send: (bytes) => {
      let binary = "";
      for (const byte of bytes) binary += String.fromCharCode(byte);
      signal.send({ t: "relay", data: btoa(binary) });
    },
    onMessage: (next) => {
      handler = next;
    },
    close: () => {
      signal.close();
    },
  };
}
